module.exports = __webpack_public_path__ + "static/keith@3x-e1ea054d5e10921b13be4687b42868cc.png";